/**
 * Step 09 — Health & Lifestyle
 *
 * Fields: disabilityStatus, generalHealth, healthInsurance,
 * diet, physicalActivity, sleepQuality, substanceUse, stressLevel
 *
 * @module udp-schema/step-09
 */

import { z } from 'zod';

// ─── Main Step 09 Schema ────────────────────────────────────────────────────

export const step09HealthSchema = z.object({
  /** Disability status (multi-select string array) */
  disabilityStatus: z.array(z.string().trim()).optional(),

  /** General health self-assessment */
  generalHealth: z.enum(['excellent', 'good', 'fair', 'poor', 'prefer_not_to_say']).optional(),

  /** Health insurance status */
  healthInsurance: z
    .enum(['yes_government', 'yes_private', 'yes_employer', 'no', 'ayushman_bharat'])
    .optional(),

  /** Diet — uses dating-schema diet option values */
  diet: z.string().trim().optional(),

  /** Physical activity level */
  physicalActivity: z.enum(['daily', 'few_times_week', 'weekly', 'rarely', 'never']).optional(),

  /** Sleep quality */
  sleepQuality: z.enum(['excellent', 'good', 'average', 'poor', 'irregular']).optional(),

  /** Substance use (multi-select string array) */
  substanceUse: z.array(z.string().trim()).optional(),

  /** Stress level */
  stressLevel: z.enum(['very_low', 'low', 'moderate', 'high', 'very_high']).optional(),
});

// ─── Inferred types ─────────────────────────────────────────────────────────

export type Step09HealthInput = z.infer<typeof step09HealthSchema>;
